import {
  ButtonView,
  DecoupledEditor,
  IconTableOfContents,
  Plugin,
} from 'ckeditor5';
import { QualioTableOfContentsCommand } from './QualioTableOfContentsCommand';

export class QualioTableOfContentsPlugin extends Plugin {
  static get pluginName(): string {
    return 'QualioTableOfContentsPlugin';
  }

  private _focusFirstContentRoot(editor: DecoupledEditor) {
    const firstContentRoot = [...editor.model.document.getRoots()].find(
      (root) =>
        root.rootName !== 'table-of-contents' && root.rootName !== '$graveyard',
    );
    editor.model.change((writer) => {
      if (firstContentRoot) {
        writer.setSelection(firstContentRoot, 0);
      }
    });
    editor.editing.view.focus();
  }

  init(): void {
    const editor = this.editor as DecoupledEditor;
    this.editor.commands.add(
      QualioTableOfContentsCommand.commandName,
      new QualioTableOfContentsCommand(this.editor),
    );

    editor.ui.componentFactory.add(
      QualioTableOfContentsCommand.commandName,
      (locale: any) => {
        const view = new ButtonView(locale);

        view.set({
          label: 'Toggle table of contents',
          icon: IconTableOfContents,
          tooltip: true,
          isToggleable: true,
        });

        view
          .bind('isEnabled')
          .to(
            this.editor.commands.get(
              QualioTableOfContentsCommand.commandName,
            )! as any,
            'isEnabled',
          );

        view.on('execute', () => {
          editor.execute(QualioTableOfContentsCommand.commandName);
          this._focusFirstContentRoot(editor);
        });
        return view;
      },
    );
  }
}
